import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=15cf3dc2&scoped=true"
import script from "./Account.vue?vue&type=script&lang=ts&setup=true"
export * from "./Account.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Account.vue?vue&type=style&index=0&id=15cf3dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf3dc2",
  null
  
)

export default component.exports